////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { map, cloneDeep, find, reject, isUndefined, filter } from 'lodash'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ListSearchable from '../../../components/ListSearchable'
import { tagsManagerActionCreators } from '../../../store/actions'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import {
	PageGridTitle,
	PageGridBorder,
	InputLogin,
	SearchInputWrapper,
	SearchInputButton,
	SearchReset,
	SelectInputWrapper,
	SelectInput,
	ShiftItemButton,
} from '../../../theme/GlobalCss'

//////STYLED//////
const TagsListUnaffectedManagerWrapper = styled.div`
	position: relative;
	font-size: ${(props) => props.theme.font.fs};
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
`
const UnaffectedSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
`
const UnaffectedTypeWrapper = styled.div`
	margin-right: 26px;
	& > * > select {
		font-size: ${(props) => props.theme.font.fs};
	}
`
//////STYLED//////

const TagsListUnaffectedManager = (props) => {
	const [searchValue, setSearchValue] = useState('')
	const [searched, setSearched] = useState('')
	const [sortDir, setSortDir] = useState(1) // asc by default
	const [sortColumnName, setSortColumnName] = useState(props.mode === 'user' ? 'fullName' : 'description')
	const [unaffectedTypeSelected, setUnaffectedTypeSelected] = useState(0)

	const [allData, setAllData] = useState([...props.baseData, ...props.baseDataAff])
	const [inputData, setInputData] = useState(props.baseData) // Current data shown
	const [baseSearch, setBaseSearch] = useState() // Database of searching
	const [inputSearchedData, setInputSearchedData] = useState(inputData || [])

	const { translations, tagsManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			tagsManager: state.tagsManager,
		}),
		shallowEqual
	)

	const actionsTagsManager = bindActionCreators(tagsManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleInputData = (triggerShift, arrToPass) => {
		let newinputData = cloneDeep(inputData)

		// Every item that was in affected list (checked items), we add to this list
		if (props.listObjAffected.length > 0) {
			map(props.listObjAffected, (elem, _id) => {
				const r = filter(newinputData, (o) => o.id === elem.id)

				// If affected item is not in our current list, we add it
				return r.length === 0 ? newinputData.push(elem) : null
			})
		}

		// But also cutting objects that were shifted,
		// at any time so filters can work properly
		if (triggerShift) {
			map(arrToPass, (elem) => {
				newinputData = reject(newinputData, elem)
			})
			// Send items to affected manager
			props.setListObjUnaffected(arrToPass)
			// Reset checked list
			props.setListUnaffected([])
		}

		setInputData(newinputData)
		// Everytime that items are added / remove, we redraw the search base
		setBaseSearch(newinputData)
		// And we also refresh what id currently shifted (by sum of all shifting actions)
		props.handleShiftedDataToAdd(newinputData)
	}

	// Handling of filters
	const handleGlobalSearch = () => {
		// Note that we always start from searchBase, not current input,
		// Otherwise everytime we are filtering, we are removing elements !
		if (!isUndefined(baseSearch)) {
			let b_s = cloneDeep(baseSearch)

			if (props.mode === 'user') {
				const current_type = config.filters.unaffectedType

				switch (current_type) {
					case '1':
						b_s = reject(b_s, (o) => {
							return !o.numberOfTagTotal > 0 ? true : false
						})
						break
					case '2':
						b_s = reject(b_s, (o) => {
							return o.numberOfTagTotal === 0 ? false : true
						})
						break
					default:
						break
				}
				setInputSearchedData(b_s)
			}

			let b_s2 = cloneDeep(b_s)

			if (searchValue.length > 0) {
				b_s2 = reject(b_s2, (o) => {
					let str = props.mode === 'user' ? cloneDeep(o.fullName) : cloneDeep(o.description)
					str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					let transformed_search = cloneDeep(searched)
					transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
				})
				setInputSearchedData(b_s2)
			} else {
				setInputSearchedData(b_s)
			}
		}
	}

	const handleListObjUnaffected = () => {
		let arrToPass = []
		let r
		map(props.listUnaffected, (elem) => {
			// We want to push objects, not ids,
			// so we are searching on all data available, unaffected and affected !
			r = find(allData, (o) => o.id === elem)
			if (!isUndefined(r)) {
				arrToPass.push(r)
			}
		})

		handleInputData(true, arrToPass)
	}

	const handleUnaffectedTypeSelected = (e) => {
		setUnaffectedTypeSelected(e.target.value)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (_e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: props.mode === 'user' ? translations['page__tagManagement__user_list'] : translations['page__tagManagement__kiosk_list'],
		labelSelected:
			props.mode === 'user' ? translations['page__tagManagement__user_selected'] : translations['page__tagManagement__kiosk_selected'],
		filters: {
			searchValue: searched,
			unaffectedType: unaffectedTypeSelected,
		},
		unaffectedTypes: [
			{ value: 0, label: translations['common__text__all'] },
			{ value: 1, label: translations['page__tagManagement__user_with_tag'] },
			{ value: 2, label: translations['page__tagManagement__user_without_tag'] },
		],
	}

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isCheckboxValue: true, dataHook: 'id', headerName: 'id' },
		// For labelling the item
		{
			isLabel: true,
			dataHook: props.mode === 'user' ? 'fullName' : 'description',
			headerName: props.mode === 'user' ? 'fullName' : 'description',
			sortable: true,
			alreadyTranslated: true,
			dataCounter: { column: 'numberOfTagTotal', keyword: 'tag' },
		},
	]
	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// Whenever we change filters or we shift data, we redraw the list
		handleInputData()
	}, [props.baseData, props.listObjAffected])

	useEffect(() => {
		handleGlobalSearch()
	}, [searched, unaffectedTypeSelected])

	useEffect(() => {
		handleGlobalSearch()
	}, [inputData])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TagsListUnaffectedManagerWrapper>
			<PageGridTitle>{config.name}</PageGridTitle>
			<PageGridBorder>
				<ListActions>
					{props.baseData && (
						<UnaffectedSearchWrapper>
							<SearchInputWrapper>
								<InputLogin
									value={searchValue}
									onChange={handleSearchValue}
									onKeyDown={handleSearchEnter}
									placeholder={
										props.mode === 'user'
											? translations['page__tagManagement__user_search']
											: translations['page__tagManagement__kiosk_search']
									}
								/>
								<SearchInputButton onClick={handleSearch} />
							</SearchInputWrapper>
							{searchValue.length > 0 && (
								<SearchReset
									onClick={() => {
										setSearchValue('')
										setSearched('')
									}}
								/>
							)}
						</UnaffectedSearchWrapper>
					)}
				</ListActions>
				<ListActions>
					{props.mode === 'user' && (
						<UnaffectedTypeWrapper>
							<SelectInputWrapper blueColor>
								<SelectInput width="145" onChange={handleUnaffectedTypeSelected}>
									{map(config.unaffectedTypes, (elem, id) => {
										return (
											<option key={id} value={elem.value}>
												{elem.label}
											</option>
										)
									})}
								</SelectInput>
							</SelectInputWrapper>
						</UnaffectedTypeWrapper>
					)}
					<ToggleFilters
						checked={sortDir}
						onChangeHandler={() => {
							setSortDir(sortDir === 0 ? 1 : 0)
						}}
						name="columnSort"
						labelPrev="AZ"
						labelNext="ZA"
						reverseCheck
					/>
				</ListActions>
				{props.baseData && (
					<ListSearchable
						inputData={inputSearchedData}
						inputColumns={columns}
						sortColumnName={sortColumnName}
						sortDir={sortDir}
						translationMode={true}
						inputConfig={config}
						sizeHeightActions={props.mode === 'user' ? 500 : 487}
						readOnly={props.readOnly}
						hookList={props.setListUnaffected}
						summaryList={props.listUnaffected}
					/>
				)}
				<ShiftItemButton onClick={() => handleListObjUnaffected()} active={props.listUnaffected.length > 0} modalMode={props.modalMode}>
					{props.mode === 'user' ? translations['page__tagManagement__user_link'] : translations['page__tagManagement__kiosk_link']}
				</ShiftItemButton>
			</PageGridBorder>
		</TagsListUnaffectedManagerWrapper>
	)
}

TagsListUnaffectedManager.propTypes = {}

TagsListUnaffectedManager.defaultPropTypes = {}

export default TagsListUnaffectedManager
